import { nb } from "date-fns/locale";
import {parse, format} from "date-fns";

export default function formatDate(dateString, options) {
    const defaultOptions = {
        inputFormat: "yyyy-MM-dd HH:mm",
        outputFormat: "dd.MM.yyyy HH:mm",
    }
    options = Object.assign(defaultOptions, options);
    const formatted = parse(dateString, options.inputFormat, new Date());

    return format(formatted, options.outputFormat, { locale: nb, });
}